export default __webpack_public_path__ + "static/media/fastapi.6c84dc4e.svg";